<template>
    <slot />
</template>

<script lang="ts" setup>
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTrigger,
} from "@/components/ui/dialog";
import { ref } from "vue";
import type { Reservation } from "./event.vue";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
    TableCellWithCopy,
} from "@/components/ui/table";
import DialogTitle from "@/components/ui/dialog/DialogTitle.vue";
import { useI18n } from "vue-i18n";
import { PerfectScrollbar } from "vue3-perfect-scrollbar";

const opened = ref(false);
const { t } = useI18n();

function fieldValue(field: any): string {
    if (field.type === "checkbox") {
        return field.value ? t("yes") : t("no");
    }

    if (field.value.startsWith("[") && field.value.endsWith("]")) {
        return JSON.parse(field.value).join(", ");
    }
    return field.value;
}

const props = defineProps<{
    reservation: Reservation;
}>();
</script>
